/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketSubsidyDto } from '../../models/ticket-subsidy-dto';

export interface TicketSubsidyControllerFindByTicketId$Params {
  ticketId: string;
  enrollmentScheduleId?: string;
}

export function ticketSubsidyControllerFindByTicketId(http: HttpClient, rootUrl: string, params: TicketSubsidyControllerFindByTicketId$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyDto>> {
  const rb = new RequestBuilder(rootUrl, ticketSubsidyControllerFindByTicketId.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
    rb.query('enrollmentScheduleId', params.enrollmentScheduleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketSubsidyDto>;
    })
  );
}

ticketSubsidyControllerFindByTicketId.PATH = '/api/ticket-subsidy/ticket';
